import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import { Skeleton } from 'components';
import { ShopperGroupSelectorContext } from '../../context';
import { ROUTES } from 'views/Configure/ReturnManagement/ShopperGroups/stubs';
import { ReactComponent as LinkIcon } from 'assets/img/icons/external-link.svg';

export default function Helptext() {
  const { selectedOption, isFetching, hasAccess } = useContext(
    ShopperGroupSelectorContext
  );

  const selectedId = _get(selectedOption, 'value', null);
  const redirectLink = selectedId
    ? ROUTES.SHOPPER_GROUPS_DETAILS_EDIT.replace(':id', selectedId)
    : ROUTES.HOME;

  return (
    <If test={hasAccess}>
      <If
        test={!isFetching}
        otherwise={<Skeleton width="100%" height="16px" className="mt-1" />}
      >
        <If
          test={!!selectedId}
          otherwise={
            <>
              You are modifying <strong>Global Settings</strong>. You can choose
              from your list of active customer groups here.
            </>
          }
        >
          You can edit the currently configuring customer group criterias{' '}
          <Link to={redirectLink} className={styles.link}>
            here <LinkIcon />
          </Link>
        </If>
      </If>
    </If>
  );
}
